import { render, staticRenderFns } from "./EntityViewsCrud.vue?vue&type=template&id=18372972&scoped=true"
import script from "./EntityViewsCrud.vue?vue&type=script&lang=js"
export * from "./EntityViewsCrud.vue?vue&type=script&lang=js"
import style0 from "./EntityViewsCrud.vue?vue&type=style&index=0&id=18372972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18372972",
  null
  
)

export default component.exports